import { render, staticRenderFns } from "./CompetitionHistory.vue?vue&type=template&id=194e16a0&scoped=true"
import script from "./CompetitionHistory.vue?vue&type=script&lang=js"
export * from "./CompetitionHistory.vue?vue&type=script&lang=js"
import style0 from "./CompetitionHistory.vue?vue&type=style&index=0&id=194e16a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e16a0",
  null
  
)

export default component.exports